<div class="inputs-section">
  <h4>Select the type</h4>
  <mat-form-field class="type-selection" appearance="fill">
    <mat-label>Type</mat-label>
    <mat-select data-test="NewRequestTypeSelect" [formControl]="dropdownFormControl">
      <mat-option *ngFor="let option of dropdownOptions" [value]="option">{{ option }}</mat-option>
    </mat-select>
  </mat-form-field>

  @switch (dropdownFormControl.value) {
    @case (IncumbentDropdownOptionsEnum.CONTRACT_NUMBER) {
      <app-contract-request-search-modal (selectedOptionChange)="onSelectionChange($event)"/>
    }
    @case (IncumbentDropdownOptionsEnum.VCC) {
      <app-vcc-request-search-modal (selectedOptionChange)="onSelectionChange($event)"/>
    }
  }
</div>
